// TODO: El codi que hi ha aquí és una copia de Events
import { useIntl } from 'react-intl';
import { BlockDataForm } from '@plone/volto/components';
import Schema from './schema';

const Data = (props) => {
  const { data, block, onChangeBlock, blocksConfig } = props;
  const intl = useIntl();
  const schema = Schema({ ...props, intl });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
      blocksConfig={blocksConfig}
    />
  );
};

export default Data;